import { render, staticRenderFns } from "./TablesList.vue?vue&type=template&id=6db4fb7c&scoped=true&"
import script from "./TablesList.vue?vue&type=script&lang=js&"
export * from "./TablesList.vue?vue&type=script&lang=js&"
import style0 from "./TablesList.vue?vue&type=style&index=0&id=6db4fb7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db4fb7c",
  null
  
)

export default component.exports